import cs_lang from 'vuetify/es5/locale/cs';

export const cs = {
	$vuetify: cs_lang,
	buyout: {
		deviceFinder: {
			chose_type: 'Vyberte typ',
			chose_brand: 'Vyberte značku',
			chose_model: 'Vyberte model',
			searchDevice: {
				title: 'Vyhledat Vaše zařízení',
				text:
					'Nezapomeňte, že uvedené ceny výkupu jsou orientační. Finální částku se dozvíš vždy až na prodejně.'
			}
		},
		contractForm: {
			imei_help_text: 'IMEI telefonu zjistíte zadáním *#06#',
			imei: 'IMEI vykupovaného zařízení',
			sn: 'SN vykupovaného zařízení',
			note: 'Poznámky',
			pin_or_birth_date: 'RČ/Datum narození',
			identity_card_number: 'Číslo OP/Pasu',
			identity_released_by: 'Doklad vydal',
			identity_valid_to: 'Platnost dokladu',
			degree_before_name: 'Titul',
			first_name: 'Jméno',
			last_name: 'Příjmení',
			salutation: 'Oslovení',
			chose_salutation: 'Vyberte oslovení',
			street: 'Ulice a číslo domu',
			city: 'Město',
			country: 'Stát',
			chose_country: 'Vyberte stát',
			postcode: 'PSČ',
			phone_number: 'Telefonní číslo',
			nationality: 'Státní občanství',
			place_of_birth: 'Místo narození',
			e_mail: 'E-mailová adresa',
			bank_code: 'Kód banky',
			bank_account_full_number: 'Číslo účtu',
			gender: 'Pohlaví'
		},
		give_registration_number: 'Zadejte číslo Vaší registrace',
		personal_information: 'Osobní údaje',
		send: 'Odeslat',
		save: 'Uložit',
		bad_quality:
			'Omlouváme se, uvedený produkt nemá definovanou požadovanou jakost.',
		can_not_be_buyout: 'Výkup nelze dokončit.',
		sell_online: 'Online výkup',
		send_info_email: 'Poslat nabídku na e-mail',
		send_info_email_label:
			'Zadejte prosím Váš e-mail, na který zašleme orientační nacenění přístroje',
		buyout_price: 'Vaše výkupní cena',
		info_minimal_buyout_price: 'Cena po srážkách nemůže klesnout pod minimální výkupní cenu',
		find_price_of_device: 'Zjistěte hodnotu svého zařízení',
		detail_pricing: 'Detailní nacenění dle stavu',
		data_for_contract: 'Údaje k uzavření smlouvy',
		search_for_device: 'Vyhledat Vaše zařízení',
		continue: 'Pokračovat',
		consent_to_marketing:
			'Uděluji souhlas se zasíláním personalizovaných reklamních a obchodních sdělení',
		info_price_deduction: 'Cenová srážka z důvodu nedodržení standardních podmínek výkupu',
		buying_out: 'Odprodávám',
		device_condition: 'Stav zařízení',
		category: 'Kategorie',
		deduction: 'Srážka',
		surcharge: 'Příplatek',
		thankYou: {
			preSale: {
				title:
					'Informativní nacenění bylo odesláno na Vaši e-mailovou adresu pod číslem <b>{0}</b>.',
				text:
					'Pokud budete chtít výkup dokončit zastavte se na některou z našich prodejen.'
			},
			onlineBuyout: {
				title: 'Děkujeme za provedení registrace číslo <b>{0}</b>.',
				text: 'Potvrzení registrace bylo zasláno na Tvou e-mailovou adresu.'
			}
		},
		validation: {
			not_null: 'Toto pole by nemělo být prázdné',
			invalid_email: 'Neplatný tvar e-mailu'
		},
		deviceSummary: {
			selected_device: 'Vybrané zařízení',
			bonus: 'Bonus',
			final_price: 'Informativní výkupní cena',
			final_price_w_bonus: 'Celková informativní výkupní cena'
		},
		error: {
			common: 'Chyba při zpracovávání požadavku',
			buyout_not_found: 'Výkup nebyl nalezen. Zkontrolujte číslo výkupu.'
		},
		bonus: {
			select_device_for_bonus: 'Vyberte Vaše nové zařízení',
			select_your_new_device: 'Vyberte váš nový {0}',
			select_seller_of_your_new_device: 'Vyberte prodejce Vašeho nového {0}'
		},
		partners: {
			partners: 'Partneři',
			select_province: 'Vyberte kraj',
			for_display_select_province:
				'Pro zobrazení seznamu partnerů prosím vyberte kraj',
			not_found_in_province: 'V tomto kraji nebyl nalezen žádný partner',
			back_to_home: 'Zpět na hlavní stránku',
			partners_list: 'Seznam partnerů'
		},
		logRegSwapper: {
			login: 'Přihlášení',
			log_in: 'Přihlásit',
			register: 'Registrace'
		},
		AdditionalInfoForm: {
			reciept: 'Účtenka',
			reciept_inserted: 'Účtenka vložena',
			reciept_cant_insert: 'Účtenku již nelze vložit',
			reciept_upload: 'Vložit',
			register_imei_of_new: 'Registrace IMEI nového {0}',
			register_imei_of_new_global: 'Registrace IMEI nového zařízení',
			register_sn_of_new_global: 'Registrace S/N nového zařízení',
			sn_of_new: 'S/N nového zařízení',
			imei_of_new: 'IMEI nového zařízení',
			imei_was_saved: 'Nový IMEI byl uložen.',
			sn_was_saved: 'Nový S/N byl uložen.',
			edit: 'Editovat',
			save: 'Uložit',
			order_pickup: 'Objednat svoz mého výkupu',
			order: 'Objednat',
			street: 'Ulice',
			city: 'Město',
			postal: 'PSČ',
			new_selected_model: 'Model nového zařízení',
			select_new_model_name: 'Vyberte model svého nově zakoupeného zařízení',
			new_model_was_saved: 'Vybraný model byl úspěšně uložen',
			new_model_partner_was_saved: 'Vybraný prodejce byl úspěšně uložen',
			new_model_partner_main_text: 'Zakoupeno u prodejce',
			new_model_partner_sub_text: 'Vyberte prodejce u kterého bylo nové zařízení zakoupeno',
			new_model_partner_selector: 'Vyberte prodejce'
		},
		BuyoutState: {
			buyout_paid: 'Výkupní cena byla poslána na tebou zaregistrovaný bankovní účet',
			collection_success: 'Svoz úspěšně objednán',
			collection_already_ordered: 'Svoz již byl objednán',
			something_went_wrong: 'Něco se pokazilo'
		},
		Revaluation:{
			revaluation_success: 'Navrhované přecenění přijato',
			revaluation_denied: 'Navrhované přecenění odmítnuto',
			revaluation_closed: 'Výkup již byl uzavřen'
		},
	},
	console:{
			all_partners_list: 'Seznam všech partnerů',
			choose_console_model_accessories_or_game: 'Vyberte model konzole, příslušenství nebo hry',
			detail_pricing_according_to_conditions: 'Detailní nacenění dle stavu',
			accessories_quantity: 'Počet příslušenství',
			controllers_quantity: 'Počet ovladačů',
			games_quantity: 'Počet her',
			new_buyout: 'Nový výkup',
			how_it_works: 'Jak to funguje',
			buyout: 'Výkup',
			contact: 'Kontakt',
			new_console: 'Nová Konzole',
			used_console: 'Použitá Konzole',
			phone: 'Telefon',
			mo_fri: 'Po - Pá',
			working_hours: 'Pracovní doba',
			information_protection: 'Ochrana údajů',
			official_partner: 'Oficiální partner',
			support: 'Podpora',
			legal_information: 'Pravní informace',
			informative_pricing: 'Informativní nacenění',
			personal_information_for_concluding_the_contract:
				'Osobní údaje k uzavření smlouvy',
			buyout_summary:
				'Souhrn registrace',
			send_the_amount_to_my_account: 'Peníze mi zašlete na účet:',
			overall_informative_buyout_price: 'Celková informativní cena',
			i_agree_to_the_processing_of_the_data: 'Souhlasím se zpracováním údajů.',
			more_information: 'Více informací',
			here: 'zde',
			controllers: 'Ovladače',
			games: 'Hry',
			pieces: 'Ks',
			send: 'Odeslat',
			personal_information: 'Osobní údaje',
			thank_you: 'Děkujeme, více informací dostanete mailem',
			continue_to_new_buyout: 'Pokračovat novým výkupem',
			games_buyout_not_available: 'Litujeme, momentálně není možné prodat hry.',
			accessories_buyout_not_available: 'Litujeme, momentálně není možné prodat ovladače.',
			receipt_subtitle: 'Nahraj účtenku svého nového Xboxu',
			imei_subtitle: 'Zadej S/N svého nového Xboxu',
			register_sn_of_new_xbox: 'Registrace S/N nového Xboxu',
		},
}
